import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import type { IconName } from "@frontend/components/atoms/Icon";

import { Fieldset } from "./Fieldset";
import { type FieldsetDataProps, fieldsetDataSchema } from "./Fieldset.schema";
import { FieldsetLegend } from "./FieldsetLegend";
import { FIELDSET_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [FIELDSET_TAG_NAME]: { props: FieldsetDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-fieldset": HTMLElement;
  }
}

function RWCFieldset({
  legend,
  legendIcon,
  legendAlign,
  variant,
  gap,
  orientation,
  size,
  width,
  labelAlign,
  collapsible,
  defaultOpen,
  disabled,
}: FieldsetDataProps): JSX.Element {
  return (
    <Fieldset
      variant={variant}
      gap={gap}
      orientation={orientation}
      size={size}
      width={width}
      labelAlign={labelAlign}
      collapsible={collapsible}
      defaultOpen={defaultOpen}
      disabled={disabled}
    >
      {legend !== undefined && (
        <FieldsetLegend align={legendAlign} icon={legendIcon as IconName}>
          {legend}
        </FieldsetLegend>
      )}
      <slot />
    </Fieldset>
  );
}

componentManager.register(
  rwc(FIELDSET_TAG_NAME, {
    component: RWCFieldset,
    dataSchema: fieldsetDataSchema,
    usesSlots: true,
  }),
);
